import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnDestroy, QueryList, ViewChildren, ViewEncapsulation } from "@angular/core";
import { Evaluator } from 'formiojs/utils/utils';
import { SortHelper } from '../../../helpers/sort.helper';
import { finalize, forkJoin, map, Subscription } from 'rxjs';
import _cloneDeep from 'lodash/cloneDeep';
import { ClassificationDomain, ClassificationIndicator, ClassificationQuestion, ClassificationStatus, ClassificationYears } from '../models/classification-indicators.model';
import { TooltipDialog } from '../../assessment-wrapper/tooltip-dialog/tooltip-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { showToast } from '../../toast.helper';
import { ToastrService } from 'ngx-toastr';
import { FormioLoader, ResourceNameService } from 'dp-formio';

declare var $: any;

@Component({
    selector: 'app-classification-indicator',
    templateUrl: './classification-indicator.component.html',
    // styleUrls: ['./classification-indicator.component.scss']
    encapsulation: ViewEncapsulation.None,
    // providers: [FormioLoader]
})
export class ClassificationIndicatorComponent implements OnDestroy {
    @ViewChildren('forms') forms: QueryList<any>;

    domainQuery = '';
    questionQuery = '';
    indicatorStatus = ClassificationStatus;
    isSummary = false;
    ready = false;

    domainsDecisions: ClassificationStatus[] = [];
    orginalDomains: ClassificationDomain[] = [];

    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    constructor(private dialog: MatDialog,
        private translateService: TranslateService,
        public dialogRef: MatDialogRef<ClassificationIndicatorComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public formioLoader: FormioLoader,
        private toastrService: ToastrService,
        private resourceNameService: ResourceNameService) {
        this.domainQuery = Evaluator.interpolate(this.data.customOptions.domainQuery, { data: this.data.submission, indicator: this.data.indicator });
        this.getIndicatorDomains();
        this.isSummary = this.data.isSummary;
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

    showDialog(message: string) {
        const dialogRef = this.dialog.open(TooltipDialog, {
            width: '80%',
            data: {
                dir: this.data.dir,
                message: this.translateService.instant(message)
            }
        });
    }

    close(): void {
        // this.data.indicator.domains.forEach(domain => {
        //     domain.attachmentsInstance = _cloneDeep(domain.attachments);
        // });
        // this.orginalDomains.forEach((domain, index) => {
        //     const item = this.data.indicator.domains.find(q => q.id == domain._id);
        //     if (item) this.orginalDomains[index] = { ...item };
        // })
        this.data.indicator.domains = this.orginalDomains;
        this.dialogRef.close(this.data.indicator);
    }
    changeLoading(state) {
        this.formioLoader.loading = state;
    }

    async save(domainIndex: number, expansion: any): Promise<void> {
        const indicator = _cloneDeep(this.data.indicator);
        indicator.domains[domainIndex].decision = this.domainsDecisions[domainIndex];
        const someNotComplete = indicator.domains.some(q => q.decision == ClassificationStatus.UnComplete);
        if (someNotComplete) {
            indicator.status = ClassificationStatus.UnComplete;
        } else {
            const someNotComplete = indicator.domains.every(q => q.decision == ClassificationStatus.Complete);
            if (someNotComplete) indicator.status = ClassificationStatus.Complete;
        }

        this.formioLoader.loading = true;
        this.sub = forkJoin(this.prepareCalls(indicator.domains[domainIndex], indicator))
            .subscribe(data => {
                this.data.indicator.status = indicator.status;
                this.data.indicator.isSubDomainsValids = true;
                this.data.indicator.domains[domainIndex].decision = this.domainsDecisions[domainIndex];
                this.orginalDomains[domainIndex] = _cloneDeep(this.data.indicator.domains[domainIndex]);
                this.formioLoader.loading = false;
                expansion.expanded = false;

                showToast(this.toastrService,
                    this.translateService.instant("forms.common.Saved done"),
                    this.translateService.instant("forms.common.Saved Successfully"),
                    false
                );
            }, error => {
                this.formioLoader.loading = false;
                showToast(this.toastrService,
                    this.translateService.instant("ErrorOccurred"),
                    this.translateService.instant("generalError"),
                    true
                );
            });
    }

    private prepareCalls(domain: ClassificationDomain, indicator: ClassificationIndicator) {
        const calls = [];
        calls.push(this.resourceNameService.
            patchSubmission(this.data.customOptions.domainResource,
                domain._id,
                [{

                    "op": "add",
                    "path": "/data/attachmentsFiles",
                    "value": domain.attachmentsFiles || []
                },
                {

                    "op": "add",
                    "path": "/data/notesAndRecommendations",
                    "value": domain.notesAndRecommendations || []
                },
                {

                    "op": "add",
                    "path": "/data/decision",
                    "value": domain.decision >= 0 ? domain.decision : null
                }
                ]));

        calls.push(this.resourceNameService.
            patchSubmission(this.data.customOptions.indicatorResource,
                indicator._id,
                [{

                    "op": "add",
                    "path": "/data/status",
                    "value": indicator.status >= 0 ? indicator.status : null
                },
                {

                    "op": "add",
                    "path": "/data/isSubDomainsValids",
                    "value": indicator.domains.every(q => q.isValid) || false
                }
                ]));

        return calls;
    }

    formLoad(formSettings) {
        setTimeout(() => {
            const array = $('.classification-indicator [name="data[submit]"]');
            for (let index = 0; index < array.length; index++) {
                $(array[index]).hide();
            }
        }, 250)
    }
    questionDataChanged(event, questionIndex: number, domainIndex: number) {
        this.data.indicator.score = event.indicatorScore;
        this.data.indicator.completionRate = event.indicatorCompletionRate;
        this.data.indicator.domains[domainIndex].score = event.domainScore;
        this.data.indicator.domains[domainIndex].completionRate = event.domainCompletionRate;
        this.data.indicator.domains[domainIndex].questions[questionIndex] = event.question;
        this.orginalDomains[domainIndex] = this.data.indicator.domains[domainIndex];
    }
    historyUpdated(questionIndex: number, domainIndex: number) {
        this.data.indicator.history = this.data.indicator.history;
        this.data.indicator.domains.forEach(domain => {
            domain.indicatorObject.history = this.data.indicator.history;
        });
        this.orginalDomains[domainIndex].indicatorObject = {
            _id: this.data.indicator._id,
            history: this.data.indicator.history
        };

        const tempDomain = new ClassificationDomain();
        tempDomain._id = this.orginalDomains[domainIndex]._id;
        tempDomain.indicatorObject = this.orginalDomains[domainIndex].indicatorObject;
        this.orginalDomains[domainIndex].questions[questionIndex].domainObject = tempDomain;
    }
    updateDomains(isAll = false) {
        if (!isAll) {
            this.data.indicator.domains = this.data.indicator.domains.filter(q => q.decision != ClassificationStatus.Complete);
        }
        this.data.isSummary = false;
        this.ready = false;
        setTimeout(() => this.ready = true);
    }

    loadDomainQuestions(domain: ClassificationDomain) {
        if (domain.isCached) return;
        this.formioLoader.loading = true;
        this.questionQuery = Evaluator.interpolate(this.data.customOptions.questionQuery, { data: this.data.submission, domain: domain });
        this.sub = this.resourceNameService.loadCustomByFilterdKey(this.data.customOptions.questionResource, this.questionQuery)
            .pipe(
                map((data: any[]) => {
                    return SortHelper.recursiveSort(data.map(q => { return { _id: q._id, ...q.data } }), 'asc')
                        .map(q => {
                            if (!q.attachmentsFiles?.length) q.attachmentsFiles = [];
                            const item = new ClassificationQuestion();
                            SortHelper.copyProps(q, item);

                            const tempDomain = new ClassificationDomain();
                            tempDomain._id = domain._id;
                            tempDomain.indicatorObject = domain.indicatorObject;
                            item.domainObject = tempDomain;

                            if (item.years)
                                item.years = item.years.map(o => {
                                    const oInput = new ClassificationYears();
                                    SortHelper.copyProps(o, oInput);
                                    oInput.value = oInput.value || '0';
                                    return oInput;
                                });
                            else {
                                item.years = [];
                                !item.score ? item.score = item.min || 0 : null;
                            }
                            item.orginal = _cloneDeep(item);

                            return item;
                        });
                }),
                finalize(() => this.formioLoader.loading = false))
            .subscribe(data => {
                domain.questions = data;
                domain.isCached = true;

                const domainIndex = this.orginalDomains.findIndex(q => q._id == domain._id);
                this.orginalDomains[domainIndex] = _cloneDeep(domain);
                this.ready = true;
            });
    }

    private getIndicatorDomains() {
        if (this.data.indicator.isCached) {
            this.fillDomainsDecisions();
            this.formioLoader.loading = false;
            this.ready = true;
            this.orginalDomains = _cloneDeep(this.data.indicator.domains);
            return;
        }

        this.formioLoader.loading = true;
        this.sub = this.resourceNameService.loadCustomByFilterdKey(this.data.customOptions.domainResource, this.domainQuery)
            .pipe(
                map((data: any[]) => {
                    return SortHelper.recursiveSort(data.map(q => { return { _id: q._id, ...q.data } }), 'asc')
                        .map(q => {
                            if (!q.attachmentsFiles?.length) q.attachmentsFiles = [];
                            const item = new ClassificationDomain();
                            SortHelper.copyProps(q, item);
                            item.indicatorObject = {
                                _id: this.data.indicator._id,
                                history: this.data.indicator.history,
                            };
                            return item;
                        });
                }),
                finalize(() => this.formioLoader.loading = false))
            .subscribe(data => {
                this.data.indicator.domains = data;
                this.fillDomainsDecisions();
                this.orginalDomains = _cloneDeep(this.data.indicator.domains);
                this.data.indicator.isCached = true;
                this.ready = true;
            });
    }

    private fillDomainsDecisions() {
        this.data.indicator.domains.forEach(domain => {
            this.domainsDecisions.push(domain.decision);
        });
    }
}
